module.exports = "https://web-assets.ifttt.com/packs/media/browse/search-fb3d11e5.svg";